import { Link } from "react-router-dom";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Bandarmolony",
  url: "https://bandarmolony.com/",
} as const;

export function Footer(): JSX.Element {
  return (
    <footer className="bg-transparent text-muted-foreground" aria-label="Footer">
      <div className="mx-auto flex w-full max-w-7xl flex-col md:flex-row items-center justify-center gap-2 md:gap-6 px-4 py-6 md:px-8 text-sm">
        <nav
          aria-label="Legal navigation"
          className="flex flex-wrap items-center justify-center gap-4 md:gap-6 font-medium text-foreground opacity-80"
        >
          <Link
            to="/terms"
            className="transition-colors hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Terms &amp; Conditions
          </Link>
          <Link
            to="/privacy"
            className="transition-colors hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Privacy Policy
          </Link>
          <Link
            to="/contact"
            className="transition-colors hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Contact Us
          </Link>
        </nav>

        <span className="hidden md:inline-block text-muted-foreground/50">|</span>

        <p className="text-center text-muted-foreground">
          Copyright {"\u00A9"} 2025 - BandarmoloNY. All rights reserved.
        </p>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
    </footer>
  );
}
